import { Component, Input } from '@angular/core';
import { Process } from 'src/app/core/models/process.model';

@Component({
  selector: 'app-process-steps',
  standalone: true,
  imports: [],
  templateUrl: './process-steps.component.html',
  styles: ``
})
export class ProcessStepsComponent {
  @Input() process!: Process;

}
